<template>
  <div class="box">
    <div class="treeCla">
      <el-col span="15">
        <el-tree :data="data" :props="defaultProps" @node-click="queryDataByTreeKey" ref="tree" node-key="id" :default-checked-keys="ids" ></el-tree>
      </el-col>
      <el-col span="1">
        <el-button type="primary" @click="addDataSet" size="mini">新增</el-button>
      </el-col>
    </div>
    <div  class="tableCla">
      <el-col style="margin-left: 45%">
        <el-button type="primary" :data="data"  @click="editDataSet" size="mini">修改</el-button>
      </el-col>
      <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column prop="id" label="主键id" v-if="show"></el-table-column>
        <el-table-column prop="dsName" label="数据集名称" ></el-table-column>
        <el-table-column prop="dsName" label="数据集内容" width="180"></el-table-column>
        <el-table-column prop="db_name" label="数据源" ></el-table-column>
        <el-table-column prop="ds_type" label="数据集类型" ></el-table-column>
        <el-table-column prop="db_name" label="表"></el-table-column>
        <el-table-column prop="field_id" label="字段" ></el-table-column>
        <el-table-column prop="sort" label="排序" ></el-table-column>
        <el-table-column prop="ds_id" v-if="show"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
    // import axios from "axios";

    export default {
      data(){
          return{
            show: false,
            tableData:[],
            data: [{
              label:'数据集',
              children:[]
            }],
            ids:[],
            defaultProps: {
              children: 'children',
              label: 'label'
            }
          }
      },
      mounted(){
        console.log("上个页面传来的是",this.$route)
          this.queryTreeList();
        // let id = this.$route.params.datasetId
        let data = {id:this.$route.params.datasetId}

        //this.queryDataByTreeKey(data)
        console.log(data)
        sessionStorage.clear();
      },
      methods: {
        queryDataByTreeKey(data){
          console.log("data的数据是",data)
          console.log("data.ds_id",data.id)
          // var params = {dataSetId : data.id}
          this.$http.get("/dbManage/sys-dataset/queryDataByTreeKey",{
            params:{
              dataSetId:data.id//后台:前台
            }
          }).then(resp=>{
            this.tableData = resp.data;
            console.log("点击左边数据源的查询方法",resp)
          })
        },
        addDataSet(){
          this.$router.push('/dataSourceMain')
        },
        editDataSet(){
          if (this.tableData.length == 0) {
            this.$alert('请选择左侧数据集进行修改！','提示信息',{
              confirmButtonText: '确定',
            })
          }
          //var params = {id : this.tableData[0].db_code}
          console.log("点击修改params的值是",this.tableData[0].db_code)
          this.$http.get("/dbManage/sys-datasource/queryDataSource", {
            params:{
              db_code : this.tableData[0].db_code
            }
          }).then(resp=>{
              //alert("成功")
              console.log('点击修改',resp)
            console.log("resp.data[0]",resp.data[0])
            console.log("点击修改data.ds_id",this.tableData[0].ds_id)
           this.$router.push({
             name:'dataSourceMain',
             params: {
               id: resp.data[0].id,
               db_name:resp.data[0].db_name,
               db_code: resp.data[0].db_code,
               db_link: resp.data[0].db_link,
               db_username: resp.data[0].db_username,
               db_password: resp.data[0].db_password,
               db_driver: resp.data[0].db_driver,
               db_inital_link_counts: resp.data[0].db_inital_link_counts,
               db_minimum_link_counts: resp.data[0].db_minimum_link_counts,
               db_maximum_link_counts: resp.data[0].db_maximum_link_counts,
               create_date: resp.data[0].create_date,
               datasetId:this.tableData[0].ds_id,
             }
            })
          })
        },
        queryTreeList() {
          this.$http.get("/dbManage/sys-dataset/queryTreeList").then(resp => {
            this.data[0].children = resp.data;
            console.log("初始化查询的是",resp.data)
            this.ids = [];
            for(let i = 0;i < this.data[0].children.length;i++){
              this.ids.push(this.data[0].children[i].id)
            }
          })
        }
      }
    }
</script>

<style scoped>
.tableCla{
  width: 78%;
  height: 500px;
  padding-left: 15px;
  padding-top: 3%;
  border-left: cornflowerblue 2px solid;
  }
.treeCla{
  width:20%;
  padding-left: 2%;
  padding-top: 2%;
  }
.box{
  width: 90%;
  margin-left: 5%;
  display: flex;
  flex-direction: row;
  border-top: cornflowerblue 2px solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataSource/dataSetMain.vue